<ng-container *ngIf="isVisible">
    <div [ngClass]="['text-field-container', containerClass]" [id]="field.id + '-container'">
        <mat-form-field class="full-width" [ngClass]="{ required: isRequired }">
            <mat-label *ngIf="field.label">{{ field.label | translate }}</mat-label>
            <input
                matInput
                [id]="field.id"
                [attr.formcontrolname]="field.name"
                [type]="resolvedInputType"
                [placeholder]="fieldUtils.getPlaceholder(field)"
                [readonly]="field.readonly ? true : false"
                [formControl]="control"
                [required]="isRequired"
                (change)="onTextChange($event)"
                (keydown)="onKeyDown($event)"
                [attr.maxlength]="maxLength"
                [attr.min]="minValue"
                [attr.max]="maxValue"
                [attr.step]="stepValue"
                [mask]="field.mask || ''"
                [dropSpecialCharacters]="false"
                [showMaskTyped]="false"
            />
        </mat-form-field>
        <div class="mat-error" *ngIf="hasError">
            <div *ngFor="let error of errorMessages">{{ error | translateSmart }}</div>
        </div>
    </div>
</ng-container>
